import { Layout } from 'antd';
import styled from 'styled-components';

export default styled(Layout)`
  background: ${({ theme }) => theme.colors.blueLightest};
  height: 100vh;
`;
